import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { errMsg, http } from "@/lib/api";

export const Newsletter = ({ dark = false, testid = "newsletter" }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await http.post("/submissions", { type: "newsletter", email });
      toast.success(data.duplicate ? "You're already on the list." : "You're subscribed. Welcome!");
      setEmail("");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="flex gap-2" data-testid={`${testid}-form`}>
      <input
        type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com"
        className={`field ${dark ? "!bg-white/10 !border-white/20 !text-mas-cream placeholder:!text-mas-sand/60" : ""}`}
        data-testid={`${testid}-email-input`}
      />
      <button disabled={busy} className="btn-terra !px-4 shrink-0" data-testid={`${testid}-submit-button`}>
        {busy ? "..." : <>Join <ArrowRight className="w-4 h-4" /></>}
      </button>
    </form>
  );
};
